import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  selectCompanyAddress,
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import CustomerMasterHelp from "../../help/customermasterHelp";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { SaleSummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import ViewBillModal from "../../billing/viewBillModal";
import PrintWithFooter from "../../utility/component/datagrid/printReportWithFooter";
import GeniusTableForReports from "../../utility/component/printReport";
import ReportDataTable from "../../utility/component/datagrid/ReportDataTable";

import { SaleSummaryPrintColumns } from "./printColumns";
import { SaleSummaryPrintTherminalColumns } from "./therminaColumns";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import { CallAPIPromise } from "../../billing/common";
import VoucherPrint from "./paymodeSummaryPrint";
import { Pagination } from "@mui/material";
import { ReceiptLongOutlined } from "@mui/icons-material";
import EInvoiceFlowModal from "./EInvoiceFlowModal";

const SaleSummary = () => {
  const navigate = useNavigate();
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const [fullList, setFullList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [billHelpStatus, setBillhelpStatus] = useState(false);
  const [saleType, setSaleType] = useState("Retail");
  const [billNo, setBillNo] = useState("");
  const [eInvoiceBill, setEInvoiceBill] = useState(null);
  const printRef = useRef(null);
  const paymodePrintRef = useRef();
  const [filterItem, setFilterItem] = useState("");
  const therminalRef = useRef(null);
  const PrintColumns = SaleSummaryPrintColumns(width);
  const therminalColoums = SaleSummaryPrintTherminalColumns(width);
  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
    NAME: "",
    MOBILE: "",
    CUSTOMER_NAME: "",
    CUSTOMER_MOBILE: "",
  });
  const [paymodeSummary, setPaymodeSummary] = useState([]);
  const [paymodeprintStatus, setPaymodePrintStatus] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [paymodeType, setPaymodeType] = useState("All");
  const [isTaxHide, setIsTaxHided] = useState(true);
  const [columns, setColumns] = useState(() => SaleSummaryColumns(width));
  const [totalFields,setTotalFields]=useState({})
  const [customerHelpStatus, setCustomerHelpStatus] = useState(false);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const dispatch = useDispatch();
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
 
  const token = useSelector(selectToken);
  const saleSummaryHeaderName = (field) => {
    const names = {
      INVNO: "Invoice",
      DATE: "Date",
      BILL_TYPE: "Bill Type",
      BILL_STATUS: "Bill Status",
      ORDER_TYPE: "Order Type",
      NAME: "Party Name",
      MOBILE: "Mobile",
      CUSTOMER_NAME: "Customer Name",
      CUSTOMER_MOBILE: "Cust. Mobile",
      TOTAL: "Total",
      TAX1_RATE: "CGST",
      TAX1_AMT: "CGST Amt.",
      TAX2_RATE: "SGST",
      TAX2_AMT: "SGST Amt.",
      TAX3_RATE: "IGST",
      TAX3_AMT: "IGST Amt.",
      GTOTAL: "Grand Total",
      CASH_AMOUNT: "Cash Amt.",
      CARD_AMOUNT: "Card Amt.",
      BTC_AMOUNT: "BTC Amt.",
      E_AMOUNT: "E Amount",
      E_INVOICE_ACTION: "E-Invoice",
    };
    return names[field] || field;
  };

  const getSaleSummaryTotal = (field) => {
    const fullTotal = totalFields?.[field];
    if (fullTotal !== undefined && fullTotal !== null && fullTotal !== "") {
      return Number(fullTotal);
    }

    return summaryList
      .filter((row) => row.BILL_STATUS !== "Void")
      .reduce((sum, row) => sum + Number(row[field] || 0), 0);
  };

  const tableColumns = columns.map((column) => ({
    ...column,
    headerName: saleSummaryHeaderName(column.field),
    renderHeader: undefined,
    hideOnSmall:
      column.hideOnSmall ||
      [
        "BILL_TYPE",
        "BILL_STATUS",
        "ORDER_TYPE",
        "MOBILE",
        "CUSTOMER_MOBILE",
        "TAX1_RATE",
        "TAX2_RATE",
        "TAX3_RATE",
        "E_INVOICE_ACTION",
      ].includes(column.field),
    responsivePriority:
      column.responsivePriority ??
      (["INVNO", "DATE", "NAME", "CUSTOMER_NAME", "GTOTAL", "CASH_AMOUNT"].includes(
        column.field
      )
        ? 1
        : undefined),
  }));

  const saleSummaryFooterValue = (column) => {
    if (column.field === "NAME" || column.field === "CUSTOMER_NAME") {
      return "Grand Total";
    }

    if (
      [
        "GTOTAL",
        "CASH_AMOUNT",
        "CARD_AMOUNT",
        "E_AMOUNT",
        "TOTAL",
        "BTC_AMOUNT",
        "AMOUNT",
        "TAX1_AMT",
        "TAX2_AMT",
        "TAX3_AMT",
        "DISQ_AMT",
      ].includes(column.field)
    ) {
      const total = getSaleSummaryTotal(column.field);
      return total ? FormatNumber2(total) : "";
    }

    return "";
  };

  const okButton = (type = saleType,page) => {
    console.log(type);
    setSummaryList([]);
    setPaymodeType("All");
    GetSaleSummary(
      {
        ...getCustomerData,
        table_prefix: prefix,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
        page:page?page:1
      },
      token,
      dispatch,
      setSummaryList,
      type,
      filterItem,
      setFullList,  setTotalPages,
      setCurrentPage,setTotalFields
    );
    CallAPIPromise("/api/saleReports/payModeSummary", {
      table_prefix: prefix,
      FDATE: fromDate,
      TDATE: ToDate,
    }).then((res) => {
      if (res.status === 200) {
        setPaymodeSummary(res.data.response);
      }
    });
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: landscape;
  }
`,
  });
  useEffect(() => {
    setCustomerData((e) => {
      return {
        ...e,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
      };
    });
  }, [fromDate, ToDate]);

  const isVoided = (I) => {
    if (saleType === "Retail") {
      const l = summaryList.filter(
        (s) => s.INVNO === I.INVNO && s.BILL_STATUS === "Void"
      );
      if (l[0]) {
        return {
          backgroundColor: "white",
          color: "red",
        };
      } else {
        return false;
      }
    } else {
      const l = summaryList.filter(
        (s) => s.INVNO === I.INVNO && s.BILL_STATUS === "Rejected"
      );
      if (l[0]) {
        return {
          backgroundColor: "white",
          color: "red",
        };
      } else {
        return false;
      }
    }
  };
  useEffect(() => {
    const callback = (details, data) => {

      setCustomerData({
        ...details[0],
        table_prefix: prefix,
      });
      setSummaryList(data);
      setFullList(data);
      setTotalFields(details[0].totalFields)
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("sale_summary", callback, elseFunc);
  }, []);
  useEffect(() => {
    if (paymodeType) {
      setSummaryList(
        fullList.filter((f) => {
          if (paymodeType === "All") {
            return true;
          } else {
            if (paymodeType === "Cash") {
              return f.CASH_AMOUNT > 0;
            } else {
              if (paymodeType === "Card") {
                return f.CARD_AMOUNT > 0;
              } else {
                if (paymodeType === "BTC") {
                  return f.BTC_AMOUNT > 0;
                } else {
                  if (paymodeType === "EAMOUNT") {
                    return f.E_AMOUNT > 0;
                  } else {
                    if (paymodeType === "Void") {
                      return f.BILL_STATUS === "Void";
                    }
                  }
                }
              }
            }
          }
        })
      );
    }
  }, [paymodeType]);
  const compannyAddress = useSelector(selectCompanyAddress);
  console.log(compannyAddress);
useEffect(()=>{
  const actionColumn = {
    field: "E_INVOICE_ACTION",
    accessor: "E_INVOICE_ACTION",
    type: "string",
    width: 132,
    headerClassName: "super-app-theme--header",
    align: "center",
    renderHeader: () => <div className="text-white">E-Invoice</div>,
    renderCell: (param) => {
      const bill = param.row.original;
      const disabled = bill.BILL_STATUS === "Void";
      return (
        <button
          type="button"
          disabled={disabled}
          onClick={(event) => {
            event.stopPropagation();
            setEInvoiceBill(bill);
          }}
          onDoubleClick={(event) => event.stopPropagation()}
          className="inline-flex items-center gap-1 rounded-md border border-[#fed7aa] bg-[#fff7ed] px-2 py-1 text-xs font-semibold text-[#c2410c] hover:bg-[#ffedd5] disabled:cursor-not-allowed disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400"
          title={disabled ? "Void bills cannot create an e-invoice" : "Create or view e-invoice"}
        >
          <ReceiptLongOutlined sx={{ fontSize: 15 }} />
          Create / View
        </button>
      );
    },
  };
  const reportColumns = SaleSummaryColumns(width);
  const c = saleType === "Retail" ? [...reportColumns, actionColumn] : reportColumns;
  if(isTaxHide){
    setColumns(
      c.filter((d) => {
        return (
          d.field !== "TAX1_RATE" &&
          d.field !== "TAX2_RATE" &&
          d.field !== "TAX3_RATE" &&
          d.field !== "TAX1_AMT" &&
          d.field !== "TAX2_AMT" &&
          d.field !== "TAX3_AMT" &&
          d.field !== "TOTAL"
        );
      })
    );
  }else{
    setColumns(c);
  }

},[isTaxHide, width, saleType])
  return (
    <div className=" bg-white flex flex-col h-full  overflow-y-auto ">
      <div className=" flex flex-col h-full p-3 ">
        <div>
          {window.innerWidth <= 764 ? (
            <FromToDateMobile
              maxWidth={"500px"}
              onPartyMasterSearchClick={() => {
                setPartyHelpStatus(true);
              }}
              onPrintClick={handlePrint}
              customerClear={() => {
                setCustomerName("");
                setCustomerData({
                  table_prefix: prefix,
                  FDATE: moment(fromDate).format("YYYY-MM-DD"),
                  TDATE: moment(ToDate).format("YYYY-MM-DD"),
                  NAME: "",
                  MOBILE: "",
                  CUSTOMER_NAME: "",
                  CUSTOMER_MOBILE: "",
                });
              }}
              partyClear={() => {
                setCustomerName("");
                setCustomerData({
                  table_prefix: prefix,
                  FDATE: moment(fromDate).format("YYYY-MM-DD"),
                  TDATE: moment(ToDate).format("YYYY-MM-DD"),
                  NAME: "",
                  MOBILE: "",
                  CUSTOMER_NAME: "",
                  CUSTOMER_MOBILE: "",
                });
              }}
              partyData={{
                NAME: getCustomerData.NAME,
                MOBILE: getCustomerData.MOBILE,
              }}
              onCustomerSearchClick={() => {
                setCustomerHelpStatus(true);
              }}
              customerData={{
                CUSTOMER_NAME: customerName,
                CUSTOMER_MOBILE: getCustomerData.CUSTOMER_MOBILE,
              }}
              submit={() => okButton(saleType)}
            />
          ) : (
            <>
              <FromToDate
                onPrintClick={handlePrint}
                hideReset={true}
                submit={() => okButton(saleType)}
                otherButton={
                  <div className="flex">
                    <div className="flex items-center">
                      <input
                        value={filterItem}
                        onChange={(e) => {
                          setFilterItem(e.target.value);
                        }}
                        placeholder="Filter by Item"
                        type="text"
                        className=" bg-gray-100 border text-sm outline-none px-2"
                      ></input>
                      <button
                        onClick={() => {
                          setFilterItem("");
                        }}
                        className="ml-3"
                      >
                        <i className="bi bi-x-lg text-red-500 flex items-center " />
                      </button>
                    </div>

                    {/* {width > 1400 &&
                      filterByPaymode(paymodeType, setPaymodeType)} */}
                  </div>
                }
              />
              <div className="mt-1">
                <FromToDate
                  hideDate={true}
                  onPartyMasterSearchClick={() => {
                    setPartyHelpStatus(true);
                  }}
                  customerClear={() => {
                    setCustomerName("");
                    setCustomerData({
                      table_prefix: prefix,
                      FDATE: moment(fromDate).format("YYYY-MM-DD"),
                      TDATE: moment(ToDate).format("YYYY-MM-DD"),
                      NAME: "",
                      MOBILE: "",
                      CUSTOMER_NAME: "",
                      CUSTOMER_MOBILE: "",
                    });
                  }}
                  partyClear={() => {
                    setCustomerName("");
                    setCustomerData({
                      table_prefix: prefix,
                      FDATE: moment(fromDate).format("YYYY-MM-DD"),
                      TDATE: moment(ToDate).format("YYYY-MM-DD"),
                      NAME: "",
                      MOBILE: "",
                      CUSTOMER_NAME: "",
                      CUSTOMER_MOBILE: "",
                    });
                  }}
                  otherButton={
                    paymodeSummary[0] && (
                      <button
                        onClick={() => {
                          setPaymodePrintStatus(true);
                        }}
                        className="flex items-center rounded-sm shadow-sm  ml-2 "
                        style={{
                          backgroundColor: "#93c5fd",
                          paddingLeft: 30,
                          paddingRight: 30,
                          paddingTop: 4,
                          paddingBottom: 4,
                          color: "black",
                          height: "32px",
                        }}
                      >
                        <i className="bi bi-printer pr-2"></i>
                        <div className="flex items-center text-sm">
                          Paymode Print
                        </div>
                      </button>
                    )
                  }
                  hideReset={true}
                  partyReset={() => {
                    setCustomerData((e) => {
                      return {
                        ...e,
                        table_prefix: prefix,
                        FDATE: moment(fromDate).format("YYYY-MM-DD"),
                        TDATE: moment(ToDate).format("YYYY-MM-DD"),
                        NAME: "",
                        MOBILE: "",
                      };
                    });
                    setCustomerName("");

                    setSummaryList([]);
                  }}
                  partyData={{
                    NAME: getCustomerData.NAME,
                    MOBILE: getCustomerData.MOBILE,
                  }}
                  onCustomerSearchClick={() => {
                    setCustomerHelpStatus(true);
                  }}
                  customerData={{
                    CUSTOMER_NAME: customerName,
                    CUSTOMER_MOBILE: getCustomerData.CUSTOMER_MOBILE,
                  }}
                />
              </div>
            </>
          )}
        </div>

        <div className="bg-[#e6e4e4] p-1 w-fit rounded-sm mt-2  flex">
          <button
            type="button"
            onClick={() => navigate("/e_invoice_hub")}
            className="mr-2 whitespace-nowrap rounded-sm bg-slate-900 px-4 py-1 text-sm font-semibold text-white hover:bg-slate-800"
          >
            E-Invoice Hub
          </button>
          <button
            onClick={() => {
              setSaleType("Retail");
              okButton("Retail");
            }}
            className={`${
              saleType === "Retail" ? "bg-brown  text-white" : ""
            } py-1 px-5   rounded-sm flex-1 text-center`}
          >
            Summary
          </button>
          <button
            onClick={() => {
              setSaleType("Orders");
              okButton("Orders");
            }}
            className={`${
              saleType === "Orders" ? "bg-brown  text-white" : ""
            } py-1 px-5  rounded-sm flex-1 text-center`}
          >
            Orders
          </button>
          {compannyAddress?.dealer_order_mode === "Yes" && (
            <button
              onClick={() => {
                setSaleType("Dealer Order");
                okButton("Dealer Order");
              }}
              className={`${
                saleType === "Dealer Order" ? "bg-brown  text-white" : ""
              } py-1 px-5  rounded-sm whitespace-nowrap flex-1 text-center`}
            >
              Bulk Order
            </button>
          )}

          {filterByPaymode(paymodeType, setPaymodeType)}
          <div className="flex ml-2 items-center text-sm pr-4">
            <div className="flex items-center ml-3">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setIsTaxHided(true);
                   
                  } else {
                    setIsTaxHided(false);
                 
                  }
                }}
                checked={isTaxHide}
                className="mr-1"
              />
              <div>Hide Tax Details</div>
            </div>
          </div>
        </div>
 
        {summaryList[0] ? (
          <div
            style={{
              height: `calc(100% - ${width <= 764 ? 220 : 170}px)`,
              width: "100%",
              marginTop: 10,
            }}
            className=" mb-2  "
          >
            <ReportDataTable
              columns={tableColumns}
              rows={summaryList}
              maxHeight="100%"
              getRowKey={(row, index) => `${row.INVNO || "bill"}-${index}`}
              onRowDoubleClick={(row) => {
                setBillNo(row.INVNO);
                setBillhelpStatus(true);
              }}
              getRowClassName={(row) =>
                row.BILL_STATUS === "Void" || row.BILL_STATUS === "Rejected"
                  ? "text-red-600"
                  : ""
              }
              footerValue={saleSummaryFooterValue}
              emptyTitle="No sale summary data found"
              emptyDescription="Select filters and run the summary to view sale data."
            />
            {totalPages > 1 && (
              <div className="flex w-full justify-center pt-2">
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(e, v) => {
                    okButton(saleType, v);
                  }}
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "#000",
                      backgroundColor: "#f3f4f6",
                      borderRadius: "8px",
                      margin: "0 4px",
                      minWidth: "36px",
                      height: "36px",
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#e5e7eb",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#000 !important",
                      color: "#fff !important",
                    },
                    "& .Mui-selected:hover": {
                      backgroundColor: "#000",
                    },
                  }}
                />
              </div>
            )}

            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={printRef}>
                  <NewPrintReport
                    title={"Sale Summary"}
                    data={summaryList}
                    details={[
                      {
                        name: "From Date",
                        value: moment(fromDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "To Date",
                        value: moment(ToDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "Party Name",
                        value: getCustomerData.NAME,
                      },
                    ]}
                    columns={PrintColumns}
                    footer={
                      <Footer
                        isFeilds={
                          <div className="flex justify-end text-sm mt-2">
                            <div>
                              <div className="flex ">
                                <div className="font-semibold w-[160px] text-right ">
                                   Grand Total :
                                </div>
                                <div className="ml-2 flex flex-1 justify-end ">
                                  {FormatNumber2(
                                    summaryList.reduce(
                                      (acc, row) => acc + Number(row.GTOTAL),
                                      0
                                    )
                                  )}
                                </div>
                              </div>
                              <div className="flex ">
                                <div className="font-semibold w-[160px] text-right ">
                                  Full Pages Grand Total :
                                </div>
                                <div className="ml-2 flex flex-1 justify-end ">
                                  {FormatNumber2(totalFields?.GTOTAL
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        totalFields={totalFields}
                        columns={PrintColumns}
                        rows={summaryList}
                      />
                    }
                  />
                </div>
              </div>
            </div>
            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={therminalRef}>
                  <GeniusTableForReports
                    customeHeader={
                      <div className="items-center ">
                        <div className="text-center ">Sale Summary</div>
                        <div className="flex items-center">
                          <div className="mr-1 text-sm font-semibold flex justify-center "></div>
                          <div className="text-sm font-semibold">From :</div>
                          <div className="ml-1 text-sm">
                            {moment(fromDate).format("DD-MM-YYYY")}{" "}
                          </div>
                          <div className="text-sm font-semibold ml-2">To :</div>
                          <div className="ml-1 text-sm">
                            {moment(ToDate).format("DD-MM-YYYY")}{" "}
                          </div>
                        </div>
                      </div>
                    }
                    data={summaryList}
                    columns={therminalColoums}
                    headerWidth={true}
                    marginTop={"120px"}
                    footer={
                      <Footer columns={therminalColoums} rows={summaryList} totalFields={totalFields} />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}
      </div>
      <AccountMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              NAME: e.row.NAME,
              MOBILE: "",
              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: "",
            };
          });
          setCustomerName("");

          setPartyHelpStatus(false);
        }}
        status={partyHelpStatus}
        onClose={() => {
          setPartyHelpStatus(false);
        }}
      />
      <CustomerMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: e.row.CUSTOMER_MOBILE,
              NAME: "",
              MOBILE: "",
            };
          });
          setCustomerName(e.row.CUSTOMER_NAME);
          setCustomerHelpStatus(false);
        }}
        onClose={() => {
          setCustomerHelpStatus(false);
        }}
        status={customerHelpStatus}
      />
      <ViewBillModal
        bill_performa={saleType === "Retail" ? "bills" : "orders"}
        hideOrderSlip={true}
        setSummaryList={setSummaryList}
        status={billHelpStatus}
        billNo={billNo}
        onBack={() => setBillhelpStatus(false)}
      />
      <EInvoiceFlowModal
        open={Boolean(eInvoiceBill)}
        onClose={() => setEInvoiceBill(null)}
        invoice={eInvoiceBill}
        tablePrefix={prefix}
        companyDetails={compannyAddress}
        token={token}
      />
      <VoucherPrint
        paymodeSummary={paymodeSummary}
        status={paymodeprintStatus}
        fromDate={fromDate}
        ToDate={ToDate}
        onClose={() => {
          setPaymodePrintStatus(false);
        }}
      />
    </div>
  );
};

export default SaleSummary;
function filterByPaymode(paymodeType, setPaymodeType) {
  return (
    <div className="ml-[35px] pl-[35px] border-l flex items-center">
      <div className="pr-3 whitespace-nowrap">Filter By :</div>
      <select
        name="business_type"
        value={paymodeType}
        onChange={(e) => {
          setPaymodeType(e.target.value);
        }}
        className="border border-gray-300 rounded-md w-full py-1 outline-none "
      >
        <option>Select Paymode</option>
        {[
          {
            name: "All",
            value: "All",
          },
          {
            name: "Cash",
            value: "Cash",
          },
          {
            name: "Card",
            value: "Card",
          },
          {
            name: "BTC",
            value: "BTC",
          },
          {
            name: "EAMOUNT",
            value: "EAMOUNT",
          },
          {
            name: "Void",
            value: "Void",
          },
        ].map((c) => {
          return <option label={c.name} value={c.value} />;
        })}
      </select>
    </div>
  );
}
